import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./invoice.css";
import logo from "../../../assets/Logo/logo_Black.png";
import stamp from "../../../assets/Logo/stamp.PNG";
import { toWords } from 'number-to-words';
import MapCurrency from "../../../utils/Mappers/currency";

const InvoicePDF = ({documentData}) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const downloadPDF = async () => {
    if (!documentData) {
      alert("Invoice data is still loading. Please wait.");
      return;
    }
  
    setIsGenerating(true);
    const element = document.querySelector(".invoice-container");
    const downloadButton = document.querySelector(".download-button");
    downloadButton.style.visibility = "hidden";
    element.classList.add("pdf-export");
  
    try {
      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4", compress: true });
      const canvas = await html2canvas(element, { scale: 3, scrollX: 0, scrollY: 0, useCORS: true, backgroundColor: "#ffffff" });
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Invoice_${documentData.reference_number}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("An error occurred while generating the PDF. Please try again.");
    } finally {
      element.classList.remove("pdf-export");
      downloadButton.style.visibility = "visible";
      setIsGenerating(false);
    }
  };
  
  return (
    <div className="invoice-container">
        <header>
          <div className="header-top">
              <div className="logo-container">
                <img src={logo} alt="CADOMATION Logo" className="logo" />
                <p className="website-link">www.cadomation.com</p>
              </div>
          </div>
        <h2 style={{ textAlign: "center" }}>SALE INVOICE</h2>
        <div className="invoice-header">
            <div className="invoice-customer">
                <h4 className="label">Invoice To:</h4>
                <p><strong>{documentData?.user_profile?.name}</strong></p>
                <p>{documentData?.user_profile?.organization}</p>
                <p>{documentData?.user_profile?.address_line_1}</p>
                <p>{documentData?.user_profile?.address_line_2}</p>
                <p>{documentData?.user_profile?.email}</p>
                <p>{documentData?.user_profile?.phone}</p>
            </div>

            <div className="invoice-details">
                <p><span className="label">Invoice #:</span> {documentData?.reference_number}</p>
                <p><span className="label">Invoice Date:</span> {new Date(documentData?.created_at).toLocaleDateString("en-GB")}</p>
                {/* <p><span className="label">Client's Ref:</span> {documentData?.client_reference}</p> */}
                <p><span className="label">Payment Term:</span> {documentData?.payment_term}</p>
                <p><span className="label">Payment Method:</span> {documentData?.payment_method}</p>
            </div>

        </div>
      </header>
      <section className="invoice-items">
        <table>
          <thead>
            <tr>
              <th class="text-center">SR. NO.</th>
              <th class="text-center">DESCRIPTION</th>
              <th class="text-center">QTY</th>
              <th class="text-center">AMOUNT <br/>({MapCurrency(documentData?.currency)})</th>
              <th class="text-center">NO. OF YEARS CHARGED</th>
              {documentData?.document_items?.some((item) => item.discount && item.discount > 0) && (
                <th>DISCOUNT (%)</th>
              )}
              <th class="text-center">TOTAL<br/>({MapCurrency(documentData?.currency)})</th>
            </tr>
          </thead>
          <tbody>
            {documentData?.document_items?.map((item, index) => (
              <tr key={index}>
               <td>{index + 1}</td>
                  <td>
                    {item?.description?.split("\n").map((term, idx) => (
                      <span key={idx} className="d-block">{term.trim()}</span>
                    ))}
                  </td>
                <td>{item.quantity}</td>
                <td>{item.price}</td>
                <td>{item.no_of_years}</td>
                {documentData?.document_items.some((i) => i.discount && i.discount > 0) && (
                    <td>{item.discount ? item.discount.toFixed(2) : ""}</td>
                  )}
                <td>{item.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      
      <section className="totals">
      {documentData?.pra_percent > 0 && (
            <>
              <p>
                <strong>SUB-TOTAL: </strong> {Math.floor(documentData?.sub_total)}
              </p>
              <p>
                <strong>{documentData.type == "Quotation" ? "PRA":"Sales Tax"}@{documentData?.pra_percent}%: </strong> {(Math.floor(documentData?.sub_total) * Math.floor(documentData?.pra_percent) / 100).toFixed(2)}
              </p>
            </>
          )}
        {/* <p><strong><span style={{ color: "#34495E" }}>SUB-TOTAL:</span></strong> ${Math.floor(documentData?.sub_total)}</p> */}
        {/* {documentData?.discount ? <p><strong><span style={{ color: "#34495E" }}>DISCOUNT @ 20%:</span></strong> ${Math.floor(documentData?.discount)}</p> : <></>} */}
        <p><strong><span style={{ color: "#34495E" }}>TOTAL ({MapCurrency(documentData?.currency)}): </span></strong> {Math.floor(documentData?.total)}</p>
        </section>
            {/* <p><strong>Amount in words:</strong> <em>{toWords(Math.floor(documentData?.total))} only</em></p> */}
        {/* <section className="bank-details">
        <h3>Bank Transfer Details</h3>
        <p><strong>Bank:</strong> HABIB METROPOLITAN BANK LTD.</p>
        <p><strong>Branch:</strong> TOWNSHIP BRANCH, LAHORE</p>
        <p><strong>Bank Country:</strong> PAKISTAN</p>
        <p><strong>Account Title:</strong> CADOMATION (PRIVATE) LIMITED</p>
        <p><strong>IBAN:</strong> PK66 MPBL 0412 0671 4013 3494</p>
        <p><strong>Swift Code:</strong> MPBLPKKAXXX</p>
        </section> */}
              {/* <hr /> */}
         <div className="signatory-container">
            <div className="authorized-signatory">
              <hr />
              <p>Authorized Signatory</p>
              <img src={stamp} alt="Stamp Logo" className="stamp-logo" />
            </div>
          </div>
        <p style={{ color: "#A0A0A0", textAlign: "center", fontStyle: "italic" }}>
          This system-generated invoice does not require signatures.
        </p>

        <p style={{ textAlign: "start" }}>
          <strong>Note</strong>: {documentData?.notes}
        </p>

      <footer>
        <button onClick={downloadPDF} className="download-button">Download as PDF</button>
      </footer>
    </div>
  );
};

export default InvoicePDF;
